import service from '../api/limitAmountEntity.service';

//constants
const dataLimitAmountEntity = {
    limitAmountEntity: [],
    collectingsEntity: [],
    createLimitAmountEntity: '',
    deleteLimitAmountEntity: '',
    updateLimitAmountEntity: [],
    limitError: ''
}
//limitsAmountEntity
const LIST_LIMIT_AMOUNT_ENTITY = 'LIST_LIMIT_AMOUNT_ENTITY'
const LIST_COLLECTING_ENTITY = 'LIST_COLLECTING_ENTITY'
const CREATE_LIMIT_AMOUNT_ENTITY = 'CREATE_LIMIT_AMOUNT_ENTITY'
const DELETE_LIMIT_AMOUNT_ENTITY = 'DELETE_LIMIT_AMOUNT_ENTITY'
const UPDATE_LIMIT_AMOUNT_ENTITY = 'UPDATE_LIMIT_AMOUNT_ENTITY'
const ERROR_LIMIT_AMOUNT_ENTITY = 'ERROR_LIMIT_AMOUNT_ENTITY'

//reducer
export default function LimitAmountEntityReducer(state = dataLimitAmountEntity, action) {
    switch (action.type) {
        case LIST_LIMIT_AMOUNT_ENTITY:
            return { ...state, limitAmountEntity: action.payload };
        case LIST_COLLECTING_ENTITY:
            return { ...state, collectingsEntity: action.payload };
        case CREATE_LIMIT_AMOUNT_ENTITY:
            return { ...state, createLimitAmountEntity: action.payload };
        case DELETE_LIMIT_AMOUNT_ENTITY:
            return { ...state, deleteLimitAmountEntity: action.payload };
        case UPDATE_LIMIT_AMOUNT_ENTITY:
            return { ...state, updateLimitAmountEntity: action.payload };
        case ERROR_LIMIT_AMOUNT_ENTITY:
            return { ...state, limitError: action.payload };
        default:
            return { ...state };
    }
}

export const findAll = (username, entity, society) => async (dispatch) => {
    const response = await service.getLimitAmountEntity(username, entity, society).then((r) => { 
        return r.data !== undefined ? r.data : r.response.data; });

        if (response.code !== undefined) {
            dispatch({
                type: ERROR_LIMIT_AMOUNT_ENTITY,
                payload: response
            });
            dispatch({
                type: LIST_LIMIT_AMOUNT_ENTITY,
                payload: []
            });
        } else {
            dispatch({
                type: ERROR_LIMIT_AMOUNT_ENTITY,
                payload: ''
            });
            dispatch({
                type: LIST_LIMIT_AMOUNT_ENTITY,
                payload: response
            });
        }


}

export const createLimitAmountEntity = (limitAmountEntity, username) => async (dispatch) => {
    const response = await service.getCreateLimitAmountEntity(limitAmountEntity, username).then((r) => { 
        return r.data !== undefined ? r.data : r.response.data; });
        if (response.error !== undefined) {
            dispatch({
                type: ERROR_LIMIT_AMOUNT_ENTITY,
                payload: response
            });
            dispatch({
                type: CREATE_LIMIT_AMOUNT_ENTITY,
                payload: ''
            });
        } else {
            dispatch({
                type: ERROR_LIMIT_AMOUNT_ENTITY,
                payload: ''
            });
            dispatch({
                type: CREATE_LIMIT_AMOUNT_ENTITY,
                payload: response
            });
        }
}

export const deleteLimitAmountEntity = (lsData,username) => async (dispatch) => {
    const response = await service.getDeleteLimitAmountEntity(lsData,username).then((r) => { 
        return r.data !== undefined ? r.data : r.response.data;});

        if (response.error !== undefined) {
            dispatch({
                type: ERROR_LIMIT_AMOUNT_ENTITY,
                payload: response
            });
            dispatch({
                type: DELETE_LIMIT_AMOUNT_ENTITY,
                payload: ''
            });
        } else {
            dispatch({
                type: ERROR_LIMIT_AMOUNT_ENTITY,
                payload: ''
            });
            dispatch({
                type: DELETE_LIMIT_AMOUNT_ENTITY,
                payload: response
            });
        }

}

export const updateLimitAmountEntity = (limitAmountEntity, username) => async (dispatch) => {
    const response = await service.getUpdateLimitAmountEntity(limitAmountEntity, username).then((r) => {
        return r.data !== undefined ? r.data : r.response.data;
    });
    if (response.error !== undefined) {
        dispatch({
            type: ERROR_LIMIT_AMOUNT_ENTITY,
            payload: response
        });
        dispatch({
            type: CREATE_LIMIT_AMOUNT_ENTITY,
            payload: ''
        });
    } else {
        dispatch({
            type: ERROR_LIMIT_AMOUNT_ENTITY,
            payload: ''
        });
        dispatch({
            type: CREATE_LIMIT_AMOUNT_ENTITY,
            payload: response
        });
    }
     

}